import React from 'react';
import { useLocation } from 'react-router-dom';
import GeneralSettings from './screens/GeneralSettings';
import ModuleCreation from './screens/ModuleCreation';
import ScreenCreation from './screens/ScreenCreation';

/**
 * Administration Container Component
 * 
 * This is the main entry point for the Administration module.
 * It's designed to be decoupled and can be used by different roles (Admin, Super Admin, Managers).
 * 
 * @component
 */
const AdministrationContainer = () => {
  const location = useLocation();
  const pathname = location.pathname;
  
  // Determine which screen to render based on the current path
  let CurrentScreen = null;
  
  if (pathname.includes('/modules') || pathname.endsWith('/administration/modules')) {
    CurrentScreen = ModuleCreation;
  } else if (pathname.includes('/screens') || pathname.endsWith('/administration/screens')) {
    CurrentScreen = ScreenCreation;
  } else if (pathname.includes('/general-settings') || pathname.endsWith('/administration/general-settings')) {
    CurrentScreen = GeneralSettings;
  } else if (pathname.includes('/administration')) {
    // Default to Module Creation if just /administration
    CurrentScreen = ModuleCreation;
  } else {
    // Fallback to Module Creation
    CurrentScreen = ModuleCreation;
  }
  
  return (
    <div className="administration-container">
      {CurrentScreen && <CurrentScreen />}
    </div>
  );
};

export default AdministrationContainer;

